import React from "react";
import { InputNotificationType, MultiSelect } from "../../Helpers/Input/Input";
import trans from "../../../utils";

export default function NotifyConfiguration({ setChannel, addData }) {
  let options = [
    { value: "web", label: "Web" },
    { value: "mail", label: "Mail" },
  ];

  const selectedValues = Array.isArray(addData.values.notificators)
    ? addData.values.notificators.map((value) =>
        options.find((option) => option.value === value)
      )
    : addData.values.notificators
    ? addData.values.notificators
        .split(",")
        .map((value) => options.find((option) => option.value === value))
    : [];

  return (
    <div className="userinfo mb-24">
      <p className="fs-16 fw-700 brand-700 text-uppercase">
        {trans("configuration")}
      </p>
      <InputNotificationType
        title={trans("Type")}
        type="text"
        formstyle="form-input"
        id="type"
        name="type"
        onBlur={() => addData.setFieldTouched("type", true)}
        onChange={(value) => addData.setFieldValue("type", value ? value : "")}
        errors={addData.errors.type}
        touched={addData.touched.type}
        value={addData.values.type || ""}
      />
      {/** <MultiSelect
        title="Channels"
        options={options}
        setSelected={setChannel}
        onBlur={addData.handleBlur}
        value="web"
        errors={addData.errors.notificators}
        touched={addData.touched.notificators}
      />*/}
    </div>
  );
}
